export { default as HUIRangeInput } from './hui-range-input';
export type { HUIRangeInputProps } from './types';
